import React, {useState} from 'react'

import fire from './fire'
const ResetPassword =() =>{
    const [email, setEmail] = useState()
    const handleSubmit = () =>{
        var auth = fire.auth()
        auth.sendPasswordResetEmail(email)
    .then(() =>{
        console.log("done");
    })
    .catch(error =>{
        console.log(error);
    })
    }
    return (
        <section className = "" >
        
        <header className="mb-4 shadow">
        <nav className="navbar navbar-dark bg-dark primary-styled-border">
          <div className="container">
            <h1 style={{ fontSize: '2.25rem' }}>
                <span className="text-primary1">&lt;/&gt; </span>
                <span style={{ color: 'white' }}>Code</span><span className="text-primary1">Zap</span>
            </h1> 
            <div>
              
            </div>
          </div>
        </nav>
      </header>


         <section className = "login">

         <div className="container">
      <div className="row align-items-center">
        
        <div className="col-lg-12">
          <div className="container">
            <div className="row">
            <div className = "loginContainer">
            <img
                src="/iste.png"
                style = {{width: "20%",alignSelf: "center",marginBottom: "10%", marginTop:"-1%"}}
                
                alt=""
                loading="lazy"
                // layout="fill"
              />
              
            <label>Email</label>
            <input 
                type = "text" 
                autoFocus 
                required 
                value = {email} 
                onChange = {(e) => setEmail(e.target.value)}
            /> 
            
            <div className = "btnContainer">
                <button style = {{ backgroundColor:"#ff405f"}} onClick = {handleSubmit}>Submit</button>
            </div>
        </div>
            </div>
          </div>
        </div>
      </div>
    </div>
          
         </section>
    </section>
     )
}

export default ResetPassword